import { ArpeggiSupportedChain } from '@arpeggi/shared'
import { NftContract } from 'alchemy-sdk'
import { getAlchemyForChain } from '../../alchemy'

export const getCollectionMetadata = async ({
  collectionAddress,
  chain
}: {
  collectionAddress: string
  chain: ArpeggiSupportedChain
}): Promise<NftContract | null> => {
  const alchemy = getAlchemyForChain(chain)
  const resp = await alchemy.nft.getContractMetadata(collectionAddress)
  return resp
}
